import React, { useState } from 'react'

import { Avatar } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { bool, string } from 'prop-types'

import i18n from 'Pods/Shared/I18n'
import { useUserData } from 'Pods/UnifiedNavigation/Hooks/useUserData'

import GuestActions from './Components/GuestActions/GuestActions'
import { useUserMenu } from './Hooks/useUserMenu'

// UserInfoMenu is only needed once a signed-in user opens the menu, so it is
// lazy-loaded on first hover/click (mirrors the cart/inbox widget loading pattern).
let UserInfoMenu

function UserMenu({
  isCurrentUser = false,
  locale = 'en',
  newRoyaltyUi = false,
  showFreeTrialTag = false,
  freeTrialLabel = '',
}) {
  const { userData, handleLogout } = useUserData(isCurrentUser)
  const { isOpen, setIsOpen, wrapperRef } = useUserMenu()
  const t = (key) => i18n.t(key, { ns: 'rails', lng: locale })

  const [isUserInfoMenuLoaded, setIsUserInfoMenuLoaded] = useState(false)

  const isLoaded = isUserInfoMenuLoaded && !!UserInfoMenu

  function loadUserInfoMenu(callback) {
    if (!UserInfoMenu && !isUserInfoMenuLoaded) {
      import('Pods/LazyLoaded/UserInfoMenu/UserInfoMenu')
        .then((module) => {
          UserInfoMenu = module.default
          setIsUserInfoMenuLoaded(true)
          callback?.()
        })
        .catch((error) => {
          console.error('Failed to load UserInfoMenu:', error)
        })
    } else {
      callback?.()
    }
  }

  function handleToggle() {
    if (isOpen) {
      setIsOpen(false)
      return
    }

    if (isLoaded) {
      setIsOpen(true)
    } else {
      loadUserInfoMenu(() => setIsOpen(true))
    }
  }

  function handleMouseEnter() {
    if (!isLoaded) {
      loadUserInfoMenu()
    }
  }

  if (!isCurrentUser) {
    return <GuestActions locale={locale} />
  }

  return (
    <div className="unified-nav__user" ref={wrapperRef}>
      <button
        type="button"
        className="unified-nav__user-avatar"
        aria-haspopup="menu"
        aria-expanded={isOpen}
        aria-label={userData?.attributes?.username || t('navigation.aria.account')}
        onClick={handleToggle}
        onMouseEnter={handleMouseEnter}
      >
        <Avatar
          size="32"
          username={userData?.attributes?.username}
          img={userData?.attributes?.avatar?.large_url}
          useSingleLetter
        />
      </button>

      {isOpen && isLoaded && (
        <UserInfoMenu
          userData={userData}
          locale={locale}
          handleLogout={handleLogout}
          newRoyaltyUi={newRoyaltyUi}
          showFreeTrialTag={showFreeTrialTag}
          freeTrialLabel={freeTrialLabel}
        />
      )}
    </div>
  )
}

UserMenu.propTypes = {
  isCurrentUser: bool,
  locale: string,
  newRoyaltyUi: bool,
  showFreeTrialTag: bool,
  freeTrialLabel: string,
}

export default UserMenu
